import React from 'react';
import NavbarTwo from '../components/NavbarTwo';
import BannerTen from '../components/BannerTen';
import ProductSection from '../components/ProductSection';
import WorkProcessEight from '../components/WorkProcessEight';
import SecuritySection from '../components/SecuritySection';
import UseCasesSection from '../components/UseCasesSection';
import FeaturesSection from '../components/FeaturesSection';
import PriceAreaOne from '../components/PriceAreaOne';
import FaqAreaOne from '../components/FaqAreaOne';
import FinalCtaSection from '../components/FinalCtaSection';
import ContactAreaOne from '../components/ContactAreaOne';
import FooterNine from '../components/FooterNine';

const HomeEleven = () => {
  return (
    <>
      {/* Navbar - Header with FirmasCheck menu */}
      <NavbarTwo />

      {/* Hero Section - Banner with trust bullets */}
      <BannerTen />

      {/* Product Section - ¿Qué es FirmasCheck? */}
      <ProductSection />

      {/* How it Works - Cómo funciona */}
      <WorkProcessEight />

      {/* Security Section - Seguridad y validación */}
      <SecuritySection />

      {/* Use Cases Section - Casos de uso */}
      <UseCasesSection />

      {/* Features Section - Funcionalidades destacadas */}
      <FeaturesSection />

      {/* Pricing Section - Planes y precios */}
      <PriceAreaOne />

      {/* FAQ Section - Preguntas frecuentes */}
      <FaqAreaOne />

      {/* Final CTA Section - Llamado a la acción final */}
      <FinalCtaSection />

      {/* Contact Section - Formulario de contacto */}
      <ContactAreaOne />

      {/* Footer */}
      <FooterNine />
    </>
  );
};

export default HomeEleven;
